import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, timeout } from "rxjs";
import { BBResponseContainer } from "../carrier/response-container";
import { environment } from "../../environments/environment";
import { SearchAnnounce } from "../models/searchAnnounce";
import { ProcessUpdateDTO } from "../models/wb-process-update";
import { Sample } from "../models-new/sample";
import { SampleCommentDTO } from "../models-new/sampleCommentDTO";
import { PlateAnnouncementDTOV2 } from "../dto/plateAnnouncementDTOV2";

@Injectable({
    providedIn: 'root'
})
export class AnnouncementService {
    readonly timeoutForExcelSave = 30000;

    constructor(
        private http: HttpClient
    ) { }

    uploadManualAnnouncedData(formData: FormData): Observable<BBResponseContainer> {
        let url = environment.BB_MA_DELIVERY_API + "ma/announced/plate/file";
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(this.timeoutForExcelSave));
    }

    uploadManualAnnouncedDataV2(formData: FormData): Observable<BBResponseContainer> {
        const url = environment.BB_MA_DELIVERY_API + "ma/announced/plate/file/v2";
        return this.http.put<BBResponseContainer>(url, formData).pipe(timeout(this.timeoutForExcelSave));
    }

    announcePlates(plateAnnouncement: PlateAnnouncementDTOV2): Observable<BBResponseContainer> {
        const url = `${environment.BB_SAMPLE_PROCESSING_API}/announcePlates`;
        return this.http.post<BBResponseContainer>(url, plateAnnouncement).pipe(timeout(environment.defaultTimeout));
    }

    getAllDeliveySamples(searchAnnounce: SearchAnnounce): Observable<BBResponseContainer> {
        let url = environment.BB_MA_DELIVERY_API + "ma/announced/delivery";
        return this.http.post<BBResponseContainer>(url, searchAnnounce).pipe(timeout(environment.defaultTimeout));
    }

    getSamplesOfDelivery(labId: string, deliveryID: string) {
        let url = environment.BB_MA_DELIVERY_API + "getAllSample/" + labId + "/" + deliveryID;
        return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout));
    }

    placeRemovedSRCSample(body: any): Observable<BBResponseContainer> {
        let url = environment.BB_MA_DELIVERY_API + "sample/placeRemoved";
        return this.http.put<BBResponseContainer>(url, body).pipe(timeout(environment.defaultTimeout));
    }

    getSampleFromDelivery(labId: string, sampleId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MA_DELIVERY_API + "sample/" + labId + "/" + sampleId;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    addSampleToPlate(labId: string, sampleId: string, data: any) {
        let url = environment.BB_MA_DELIVERY_API + "addSampleToPlate/" + labId + "/" + sampleId;
        return this.http.put<BBResponseContainer>(url, data).pipe(timeout(environment.defaultTimeout));
    }

    removeSamples(body) {
        let url = environment.BB_MA_DELIVERY_API + "removeSamples";
        return this.http.put<any>(url, body).pipe(timeout(environment.defaultTimeout));
    }

    putBarcodeInSample(sampleId: string, sample: any): Observable<BBResponseContainer> {
        let url = environment.BB_MA_DELIVERY_API + "sample/barcode/" + sampleId;
        return this.http.put<BBResponseContainer>(url, sample).pipe(timeout(environment.defaultTimeout));
    }

    weatherbyProcessUpdate(processUpdateDto: ProcessUpdateDTO, proxy: boolean) {
        let url = `${environment.BB_MA_DELIVERY_API}weatherbys/processUpdate?proxy=${proxy}`
        return this.http.post<string>(url, processUpdateDto).pipe(timeout(environment.defaultTimeout))
    }

    updateSample(labId: string, sampleId: string, sample: Sample) {
        const url = `${environment.BB_MA_DELIVERY_API}updateSample/${labId}/${sampleId}`;
        return this.http.put<any>(url, sample).pipe(timeout(environment.defaultTimeout));
    }

    updateSampleComment(labId: string, sampleId: string, comment: SampleCommentDTO): Observable<BBResponseContainer> {
        const url = `${environment.BB_MA_DELIVERY_API}addComment/${labId}/${sampleId}`;
        return this.http.put<BBResponseContainer>(url, comment).pipe(timeout(environment.defaultTimeout));
    }

    addSample(labId: string, sampleId: string, sample: any): Observable<BBResponseContainer> {
        const encodedSampleId = encodeURIComponent(sampleId);
        const url = `${environment.BB_MA_DELIVERY_API}addSample/${labId}/${encodedSampleId}`;
        return this.http.post<BBResponseContainer>(url, sample).pipe(timeout(environment.defaultTimeout));
    }
    fetchNextAvailableChildSample(parentSample:Sample,workflowID:string): Observable<Sample>{
      const url = `${environment.BB_MA_DELIVERY_API}child/${workflowID}`;
      return this.http.post<BBResponseContainer>(url,parentSample).pipe(map(result => result.data as Sample),timeout(environment.defaultTimeout));
    }    

}